<template>
  <v-dialog
    :value="value"
    width="400px"
    @input="onClose"
    content-class="dialog-center-margin white"
  >
    <div class="primary pa-6 white--text d-flex justify-space-between align-center">
      <span>{{ $t('Add note') }}</span>
      <VIcon style="color: white;cursor:pointer;" medium @click="onClose">mdi-close</VIcon>
    </div>
    <textarea
      ref="textarea"
      class="pa-6 note-textarea"
      v-model="note"
      :placeholder="`${$t('Note')}...`"
      minlength="1"
      @keydown.enter.prevent="addNote"
    />
    <div class="d-flex justify-end">
      <v-btn
        color="primary"
        elevation="0"
        @click="addNote"
        class="ma-3"
        :disabled="loading || !note || note && !note.length"
      >{{$t('Confirm')}}</v-btn>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    eventId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      note: null,
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.textarea.focus();
        }, 200);
      }
    },
  },
  methods: {
    onClose() {
      this.note = null;
      this.$emit('input', false);
    },
    addNote() {
      if (this?.note?.length && !this.loading) {
        this.loading = true;
        this.$toast(this.$t('Adding note'), { id: 'noteToast', type: 'loading' });

        this.$Event.api().addNote(this.eventId, this.note).then(async () => {
          const newNotes = await this.$Event.api().getNotes(this.eventId);
          this.$Event.insertOrUpdate({
            data: [
              {
                ...this.$Event.find(this.eventId),
                notes: newNotes.response.data,
              },
            ],
          });
          this.$updateToast('noteToast', { message: this.$t('Adding note'), type: 'loadingSuccess' });
        }).finally(() => {
          this.loading = false;
        });
        this.onClose();
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .note-textarea {
    resize: none !important;
    height: 120px;

    &:focus {
      outline: none;
    }
  }
</style>
